import React from "react";

import PageContainer from "../common/PageContainer";

import BaseTable from "../table/BaseTable";

import mockLeadActivityData from "../../data/mockLeadActivityData";

import { generateLeadAnalytics } from "../../hooks/activityCalulations";

import { transformLeadAnalytics } from "../../hooks/formatLeadAnalytics";

import LeadColumns from "../../data/LeadColumns";

import "../../styles/lead_activity.css";

const { summaryColumns, viewsColumns, filtersColumns, propertiesColumns } = LeadColumns;

export default function LeadActivity() {
  /**
   * -----------------------------------------
   * GENERATE ANALYTICS
   * -----------------------------------------
   */

  const analytics =
    generateLeadAnalytics(
      mockLeadActivityData.flat()
    );

  const tableData =
    transformLeadAnalytics(
      analytics
    );


  return (
    <PageContainer>
      <div className="lead-activity-page">
        <div className="page-header">
          <h1>
            Lead Activity Analytics
          </h1>

          <p>
            User session behavior,
            views, filters, and
            property engagement
          </p>
        </div>

        {/* -------------------------------- */}
        {/* SESSION SUMMARY */}
        {/* -------------------------------- */}

        <div className="activity-section">
          <div className="section-header">
            <h2>
              Session Summary
            </h2>
          </div>

          <BaseTable
            columns={
              summaryColumns
            }
            data={tableData.summary}
          />
        </div>

        {/* -------------------------------- */}
        {/* VIEW ACTIVITY */}
        {/* -------------------------------- */}

        <div className="activity-section">
          <div className="section-header">
            <h2>
              View Activity
            </h2>
          </div>

          <BaseTable
            columns={
              viewsColumns
            }
            data={tableData.views}
          />
        </div>

        {/* -------------------------------- */}
        {/* FILTER ACTIVITY */}
        {/* -------------------------------- */}

        <div className="activity-section">
          <div className="section-header">
            <h2>
              Filter Activity
            </h2>
          </div>

          <BaseTable
            columns={
              filtersColumns
            }
            data={tableData.filters}
            expandable={{
              expandedRowRender:
                (row) => (
                    <div className="expanded-filter-content">
                    <h4>
                      Filter Interactions
                    </h4>
                  
                    {row.interactions?.length ===
                    0 ? (
                      <p>
                        No interactions found
                      </p>
                    ) : (
                      <div className="interactions-grid">
                        {row.interactions.map(
                          (
                            interaction,
                            index
                          ) => (
                            <div
                              key={index}
                              className={`interaction-card ${
                                interaction.type ===
                                "location_selected"
                                  ? "location"
                                  : "budget"
                              }`}
                            >
                              {/* LOCATION */}
                  
                              {interaction.type ===
                                "location_selected" && (
                                <>
                                  <div className="interaction-label">
                                    📍 Location
                                  </div>
                  
                                  <div className="interaction-value">
                                    {
                                      interaction.value
                                    }
                                  </div>
                  
                                  <div className="interaction-time">
                                    {
                                      interaction.timestamp
                                    }
                                  </div>
                                </>
                              )}
                  
                              {/* BUDGET */}
                  
                              {interaction.type ===
                                "budget_changed" && (
                                <>
                                  <div className="interaction-label">
                                    💰 Budget
                                  </div>
                  
                                  <div className="interaction-value">
                                    ₹
                                    {interaction.budgetMin.toLocaleString()}
                                    {" - "}
                                    ₹
                                    {interaction.budgetMax.toLocaleString()}
                                  </div>
                  
                                  <div className="interaction-time">
                                    {
                                      interaction.timestamp
                                    }
                                  </div>
                                </>
                              )}
                            </div>
                          )
                        )}
                      </div>
                    )}
                  </div>
                ),
            }}
          />
        </div>

        {/* -------------------------------- */}
        {/* PROPERTY ACTIVITY */}
        {/* -------------------------------- */}

        <div className="activity-section">
          <div className="section-header">
            <h2>
              Property Views
            </h2>
          </div>

          <BaseTable
            columns={
              propertiesColumns
            }
            data={
              tableData.properties
            }
          />
        </div>
      </div>
    </PageContainer>
  );
}